import Descriptions from "./Descriptions";
import BuyNow from "./BuyNow";
import Authors from "./Authors";
import Reviews from "./Reviews";
import { useEffect, useState } from "react";
import "../../assets/css/bookDetail.css";
import "../../assets/css/share-svg.css";
import { useSelector } from "react-redux";
import { BOOK_DETAIL } from "../../constants/APIEndpointConstants";
import { makeGetRequest } from "../../rest/RestService";
import { HOME_CRUMB } from "../../constants/BreadcrumConstants";
import Breadcrumb from "../breadcrumb/Breadcrumb";
import { Loader } from "../general/Loader";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import { useHistory } from "react-router";
import { ManageScroll } from "../../helper/ManageScroll";
import PageNotFound from "../not-found/PageNotFound";
import { Viewer, Worker, SpecialZoomLevel } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const BookDetails = () => {
  const location = useLocation();
  const [bookDetail, setBookDetail] = useState({});
  const [loader, setLoader] = useState(true);
  const { code, error } = useSelector((state) => state.geolocation);
  const { hfData, error: hfError } = useSelector((state) => state.hfReducer);
  const history = useHistory();
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const url = `${BOOK_DETAIL}/${code}/${query.get("book_slug")}`;
    setLoader(true);
    if (code && hfData?.header) {
      makeGetRequest(url)
        .then((res) => setBookDetail(res.data))
        .catch((err) => setBookDetail({ error: err.message }))
        .finally(() => {
          setLoader(false);
          ManageScroll(history);
        });
    }
  }, [code, location.search, history, hfData?.header]);
  // const pinTitle = `${bookDetail?.book_detail?.title}, ${bookDetail?.book_detail?.description?.split(".")?.[0]}`;
  const pinTitle = `${bookDetail?.book_detail?.meta_description}`;

  const otherDataFound =
    bookDetail?.toc ||
    bookDetail?.book_detail?.about_author ||
    bookDetail?.book_detail?.book_review;

  const socialDesc = `${bookDetail?.book_detail?.description?.split(".")?.[0].replace(/(<([^>]+)>)/ig, '')}`;
  const pinTitleString = `${pinTitle.replace(/(<([^>]+)>)/ig, '')}`;

  const [isPopupVisible, setPopupVisible] = useState(false);
  const handleClose = () => setPopupVisible(false);
  const handleShow = () => setPopupVisible(true);

  const renderToolbar = (Toolbar) => (
    <Toolbar>
      {(slots) => {
        const {
          CurrentPageInput,
          EnterFullScreen,
          GoToNextPage,
          GoToPreviousPage,
          NumberOfPages,
          ShowSearchPopover,
          Zoom,
          ZoomIn,
          ZoomOut,
        } = slots;
        return (
          <div
            style={{
              alignItems: "center",
              display: "flex",
              width: "100%",
            }}
          >
            <div style={{ padding: "0px 2px" }}>
              <ShowSearchPopover />
            </div>
            <div style={{ padding: "0px 2px" }}>
              <ZoomOut />
            </div>
            <div style={{ padding: "0px 2px" }}>
              <Zoom />
            </div>
            <div style={{ padding: "0px 2px" }}>
              <ZoomIn />
            </div>
            <div style={{ padding: "0px 2px", marginLeft: "auto" }}>
              <GoToPreviousPage />
            </div>
            <div style={{ padding: "0px 2px", width: "4rem" }}>
              <CurrentPageInput />
            </div>
            <div style={{ padding: "0px 2px" }}>
              / <NumberOfPages />
            </div>
            <div style={{ padding: "0px 2px" }}>
              <GoToNextPage />
            </div>
            <div style={{ padding: "0px 2px", marginLeft: "auto" }}>
              <EnterFullScreen />
            </div>
          </div>
        );
      }}
    </Toolbar>
  );

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: (defaultTabs) => [
      // Remove the attachments tab (\`defaultTabs[2]\`)
      defaultTabs[0], // Bookmarks tab
      defaultTabs[1], // Thumbnails tab
    ],
    setInitialTab: () => Promise.resolve(1),
    renderToolbar,
  });

  return (
    <>
      {loader ? (
        <Loader />
      ) : bookDetail?.book_detail?.title && !error && !hfError ? (
        <>
          <Header data={hfData} />
          <Helmet>
            <title>{bookDetail?.book_detail?.title}</title>
            <meta property="og:type" content="website" />
            <meta property="og:title" content={bookDetail?.book_detail?.title} />
            <meta property="og:url" content={bookDetail?.yoast_head_json?.og_url} />
            <meta property="og:image" content={bookDetail?.book_detail?.img_path || " "} />
            <meta property="og:image:secure_url" content={bookDetail?.book_detail?.img_path || " "} />
            <meta property="og:image:alt" content={socialDesc} />
            <meta property="og:description" content={pinTitleString}></meta>
            <meta name="description" content={pinTitleString}></meta>
            <meta name="keywords" content={bookDetail?.book_detail?.meta_key} />
            <meta
              property="og:image:secure_url"
              content={bookDetail?.book_detail?.img_path || " "}
            />
            <meta property="og:image:width" content="400" />
            <meta property="og:image:height" content="300" />
            <meta
              property="og:image:alt"
              content={pinTitleString}
            />
            <meta property="og:site_name" content="Polity" />
          </Helmet>
          <div className="subject_bg">
            <div className="row">
              <div className="container subject_padding">
                {location?.state?.crumb ? (
                  <Breadcrumb
                    crumbs={[
                      HOME_CRUMB,
                      ...location?.state?.crumb,
                      {
                        title: `${bookDetail?.book_detail?.title}`,
                      },
                    ]}
                  />
                ) : (
                  <Breadcrumb
                    crumbs={[
                      HOME_CRUMB,
                      {
                        title: `${bookDetail?.book_detail?.title}`,
                      },
                    ]}
                  />
                )}
                <Descriptions
                  bookDetail={bookDetail?.book_detail}
                  socialIcon={bookDetail?.social_arr?.social_links}
                />
              </div>
            </div>
          </div>
          <BuyNow
            bookDetail={bookDetail}
            handleShow={handleShow}
            handleClose={handleClose}
          />
          {(bookDetail?.book_detail?.toc ||
            bookDetail?.book_detail?.about_author) && (
            <Authors
              toc={bookDetail?.book_detail?.toc}
              aboutAuthor={bookDetail?.book_detail?.about_author}
            />
          )}
          {bookDetail?.book_detail?.book_review && (
            <Reviews reviews={bookDetail?.book_detail?.book_review} />
          )}
          {isPopupVisible && bookDetail?.book_detail?.pdf_preview && (
            <>
              <Modal
                show={isPopupVisible}
                onHide={handleClose}
                dialogClassName="pdf-modal"
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header>
                  <Button variant="secondary" onClick={handleClose}>
                    X
                  </Button>
                </Modal.Header>
                <Modal.Body>
                  <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.js">
                    <Viewer
                      fileUrl={bookDetail?.book_detail?.pdf_preview}
                      defaultScale={SpecialZoomLevel.PageFit}
                      plugins={[
                        // Register plugins
                        defaultLayoutPluginInstance,
                      ]}
                    />
                  </Worker>
                </Modal.Body>
              </Modal>
            </>
          )}
          {!otherDataFound && <div className="empty-container" />}
          <Footer data={hfData} />
        </>
      ) : (
        <PageNotFound pageError={bookDetail?.error || hfError || error} />
      )}
    </>
  );
};

export default BookDetails;
